<div class="panel-firmante-card datos-nif-card"
     [ngStyle]="colorVars"
     [class.panel-firmante-card--expandido]="firmanteDetalle && mostrarDetalleNif">
  <form [formGroup]="firmanteNifForm">
    <div class="panel-firmante-card__header"
         [class.panel-firmante-card__header--clickable]="mostrarDetalleNif"
         (click)="onHeaderClick()">
      <span class="panel-firmante-card__badge"></span>
      <input *ngIf="mostrarDetalleNif"
             id="incluirFirmante"
             class="panel-firmante-card__checkbox"
             type="checkbox"
             formControlName="incluirFirmante"
             (click)="$event.stopPropagation(); getClickCheckboxNoGenerico('noGenerico')">
      <input *ngIf="!mostrarDetalleNif"
             id="incluirFirmante"
             class="panel-firmante-card__checkbox"
             type="checkbox"
             formControlName="incluirFirmante"
             [ngStyle]="{'cursor': tipoFirmante.checkSiCopiaBasica ? 'default' : 'pointer'}"
             (click)="$event.stopPropagation(); getClickCheckboxGenerico('generico')">
      <h6 class="panel-firmante-card__titulo">{{ tipoFirmante.desc }}</h6>
      <svg *ngIf="mostrarDetalleNif"
           class="panel-firmante-card__arrow"
           [class.panel-firmante-card__arrow--up]="firmanteDetalle"
           (click)="$event.stopPropagation(); mostrarDetalle()">
        <use xlink:href="#hs-arrow"></use>
      </svg>
    </div>

    <div class="panel-firmante-card__body datos-nif-card__body" *ngIf="firmanteDetalle && mostrarDetalleNif">
      <div class="flex-box">
        <div class="flex">
          <input type="radio" formControlName="posicionNif" value="pagina" (click)="borrarInputContrario('pagina')">
          <div class="flex-input" style="margin-right: 25px">
            <label for="nifPage">Página</label>
            <input type="number" formControlName="nifPage" (keyup)="anadirValoresNif()" [ngClass]="formularioValidacionesDocsService.isCampoValidoArray('nifPage', obtenerIndexNifArray()) && obtenerIndexNifArray() > -1 ? 'errorInput':'' " [readOnly]="posicionNif.value!=='pagina'">
          </div>
          <div class="flex-input">
            <label for="nifOrden">Orden</label>
            <input type="number" formControlName="nifOrden" (keyup)="anadirValoresNif()" [ngClass]="formularioValidacionesDocsService.isCampoValidoArray('nifOrden', obtenerIndexNifArray()) && obtenerIndexNifArray() > -1? 'errorInput':'' " [readOnly]="posicionNif.value!=='pagina'">
          </div>
        </div>
        <mat-spinner *ngIf="cargando" diameter="30" strokeWidth="2" style="margin-top: 25px;"></mat-spinner>
        <div *ngIf="!cargando && nif!==''" class="nif">
          NIF: {{ nif }}
        </div>
      </div>
      <div class="flex-box">
        <input type="radio" formControlName="posicionNif" value="formulario" (click)="borrarInputContrario('formulario')">
        <div class="flex-input">
          <label for="nifFormulario">Formulario</label>
          <input type="text" class="text-largo" formControlName="nifFormulario" (keyup)="anadirValoresNif()" [ngClass]="formularioValidacionesDocsService.isCampoValidoArray('nifFormulario', obtenerIndexNifArray()) && obtenerIndexNifArray() > -1 ? 'errorInput':'' " [readOnly]="posicionNif.value!=='formulario'">
        </div>
      </div>
      <span *ngIf="obtenerIndexNifArray() > -1">
        <p class="texto-validacion" *ngIf="formularioValidacionesDocsService.isCampoValidoArray('nifPage', obtenerIndexNifArray())">
          {{ formularioValidacionesDocsService.mensajeErrorNifPage }}
        </p>
        <p class="texto-validacion" *ngIf="formularioValidacionesDocsService.isCampoValidoArray('nifOrden', obtenerIndexNifArray())">
          {{ formularioValidacionesDocsService.mensajeErrorNifOrden }}
        </p>
        <p class="texto-validacion" *ngIf="formularioValidacionesDocsService.isCampoValidoArray('nifFormulario', obtenerIndexNifArray())">
          {{ formularioValidacionesDocsService.mensajeErrorNifFormulario }}
        </p>
        <p class="texto-validacion" *ngIf="datosConfiguracionDocumentosService.noExistenNifs[obtenerIndexNifArray()]">Nif no encontrado. Informe de una página y orden válidos.</p>
        <p class="texto-validacion" *ngIf="formularioValidacionesDocsService.isCampoValidoArray('posicionNif', obtenerIndexNifArray())">
          {{ formularioValidacionesDocsService.mensajeErrorPosicionNif }}
        </p>
      </span>
    </div>
  </form>
</div>
